import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from 'src/app/core/course.service';
import { Course } from 'src/app/models/course.model';

@Component({
  selector: 'app-edit-course',
  templateUrl: './edit-course.component.html',
  styleUrls: ['./edit-course.component.scss'],
  standalone: false
})
export class EditCourseComponent {
  
  @Input() course?: Course;
  @Output() finished: EventEmitter<any> = new EventEmitter<any>();

  form!: FormGroup;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private courseService: CourseService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      color: ['', [Validators.required]]
    });
  }

  ngOnChanges() {
    if (this.course) {
      this.form.setValue({name: this.course?.name, color: this.course?.color});
    }
  }

  updateCourse() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.course!.name = this.form.value['name'];
    this.course!.color = this.form.value['color'];
    this.isLoading = true;
    this.courseService.updateCourse(this.course!).subscribe((result) => {
      this.isLoading = false;
      this.finished.emit();
    });
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }

  backToCourse() {
    this.router.navigate([`courses/${this.course!.id}`]);
  }

  deleteCourse() {
    this.courseService.deleteCourse(this.course!.id!).subscribe();
    this.router.navigate([`courses`]);
  }
}
